import { render } from "./EyHeaderLogo.vue?vue&type=template&id=8f0426ee&scoped=true"
const script = {}

import "./EyHeaderLogo.vue?vue&type=style&index=0&id=8f0426ee&lang=scss&scoped=true"

import exportComponent from "C:\\__MRYNK\\_2022\\ey-padel-matchmaking-app\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0426ee"]])

export default __exports__